import React, { Component } from "react";
import ReactLoading from "react-loading";
import Layout from "./components/Layout";
import blueImg from "../allUser/images/user-1.png";
import { getUsers } from "../services/userServices";
import { Button, Dropdown } from "react-bootstrap";
import AddUserModal from "./components/AddUserModal";
import DeleteUserModal from "./components/DeleteUserModal";
import toast from "react-hot-toast";
import keycloak from "../keycloak";

class AllUsers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      team: "Blue.OODA",
      currentPage: 1,
      showUsersNo: 10,
      items: [],
      filteredItems: [],
      DataisLoaded: false,
      isOpen: false,
      searchTerm: "",
      showUserModal: false,
      editMode: false,
      editUserId: "",
      showDeleteModal: false,
      userToDelete: null,
    };
    this.setEditMode = this.setEditMode.bind(this);
  }

  componentDidMount() {
    getUsers().then((json) => {
      this.setState(
        {
          items: json,
          filteredItems: json,
          DataisLoaded: true,
        },
        () => {
          // Initialize the first page of data
          this.updateDisplayedData(1);
        }
      );
    });
  }

  handleSearch = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    const filteredItems = this.state.items.filter((user) =>
      user.email?.toLowerCase().includes(searchTerm)
    );

    this.setState(
      {
        searchTerm,
        filteredItems,
        currentPage: 1,
      },
      () => {
        this.updateDisplayedData(1);
      }
    );
  };

  dataSortByTeam = (team) => {
    const filteredItems = this.state.items.filter(
      (user) => user.team_name === team
    );
    this.setState(
      {
        filteredItems,
        currentPage: 1,
      },
      () => {
        this.updateDisplayedData(1);
      }
    );
  };

  setShowUserModal() {
    this.setState({ showUserModal: false });
  }

  updateDisplayedData = (pageNumber) => {
    const { showUsersNo, filteredItems } = this.state;
    const startIndex = (pageNumber - 1) * showUsersNo;
    const endIndex = startIndex + showUsersNo;
    const displayedData = filteredItems.slice(startIndex, endIndex);

    this.setState({
      currentPage: pageNumber,
      displayedData,
    });
  };

  getPaginationGroup = () => {
    const { filteredItems, showUsersNo } = this.state;
    return Math.ceil(filteredItems.length / showUsersNo);
  };

  editUser(userID) {
    this.setState({ showUserModal: true, editMode: true, editUserId: userID });
  }
  setEditMode = (mode) => {
    this.setState({ editMode: mode });
  };
  
  deleteUser(userID){
    this.setState({
      showDeleteModal: true,
      userToDelete: userID
    });
  };

  async keycloakDeleteUser(userID){
    try {
      const url = `https://oxdr-sso.invinsense.io/admin/realms/${keycloak.realm}/users/${userID}`;
      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${keycloak.token}`,
        },
      });

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);
      toast.success("User has been deleted successfully!")
    } catch (error) {
      console.log("error",error)
    }
  };


  handleDeleteConfirm = async () => {
    try {
      const userID = this.state.userToDelete;
      // Add your delete API call here
      await this.keycloakDeleteUser(userID);
      
      // After successful deletion, update the state
      const updatedItems = this.state.items.filter(user => user.id !== userID);
      this.setState({
        items: updatedItems,
        filteredItems: updatedItems,
        showDeleteModal: false,
        userToDelete: null
      }, () => {
        // Update displayed data after state update
        this.updateDisplayedData(this.state.currentPage);
      });
  
      // Optional: Add success toast/notification
    } catch (error) {
      console.error('Error deleting user:', error);
      // Optional: Add error toast/notification
    }
  }
  
  handleDeleteCancel = () => {
    this.setState({
      showDeleteModal: false,
      userToDelete: null
    });
  }

  render() {
    const { DataisLoaded, displayedData, currentPage } = this.state;

    const renderPaginationButtons = () => {
      const totalPages = this.getPaginationGroup();
      const buttons = [];

      for (let i = 1; i <= totalPages; i++) {
        buttons.push(
          <li
            className={`page-item ${currentPage === i ? "active" : ""}`}
            key={i}
          >
            <button
              className="page-link"
              onClick={() => this.updateDisplayedData(i)}
            >
              {i}
            </button>
          </li>
        );
      }
      return buttons;
    };

    const CustomToggle = React.forwardRef(({ onClick }, ref) => (
      <button
        className="btn p-0 border-0 bg-transparent"
        ref={ref}
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-three-dots-vertical"
          viewBox="0 0 16 16"
        >
          <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
        </svg>
      </button>
    ));

    const { showDeleteModal, userToDelete, items } = this.state;
    const userToDeleteName = userToDelete 
      ? items.find(user => user.id === userToDelete)?.firstName
      : '';

    return (
      <>
        <section className="dashboard">
          <Layout>
            {!DataisLoaded && (
              <div className="spin">
                <ReactLoading
                  type="spin"
                  color="#000000"
                  height="15%"
                  width="15%"
                />
              </div>
            )}

            {DataisLoaded && (
              <div className="main-pannel white-gradient">
                <div className="tab-content">
                  <div className="tab-pane active" id="allteam" role="tabpanel">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <h3 style={{ padding: "1rem 1rem 1rem 0rem" }}>Users</h3>
                      <button
                        className="btn btn-primary"
                        type="button"
                        style={{ width: "150px" }}
                        onClick={() => {
                          this.setState({ showUserModal: true });
                        }}
                      >
                        Create User
                      </button>
                    </div>

                    {/* Search Input */}
                    <div className="mb-3">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search users by username"
                        onChange={this.handleSearch}
                        style={{
                          backgroundColor: "#f8f9fa",
                          border: "1px solid #dee2e6",
                          borderRadius: "4px",
                          padding: "0.5rem",
                          color: "#212529",
                          width: "100%",
                        }}
                      />
                    </div>

                    <div className="row products-row">
                      <div className="col">
                        <div className="candidates-table-sec">
                          <div className="table-header p-3 pl-4 pr-4">
                            <div className="row">
                              <div className="col-md-3">
                                <p className="m-0 font-weight-600">Name</p>
                              </div>
                              <div className="col-md-3">
                                <p className="m-0 font-weight-600">Username</p>
                              </div>
                              <div className="col-md-3">
                                <p className="m-0 font-weight-600">Email</p>
                              </div>
                              <div className="col-md-3">
                                <p className="m-0 font-weight-600">Action</p>
                              </div>
                            </div>
                          </div>

                          <div className="table-user-data candidates-table-list bg-white">
                            {displayedData?.length > 0 ? (
                              displayedData.map((item) => (
                                <div
                                  key={item.id}
                                  className="row table-items m-0 align-items-center py-3"
                                >
                                  <div className="col-md-3 pl-4">
                                    <div className="d-flex name align-items-center">
                                      <div className="name-img mr-3">
                                        <img src={blueImg} alt="user" />
                                      </div>
                                      <p className="h6 gray-text m-0">
                                        {item.firstName} {item.lastName}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <p className="h6 gray-text m-0">
                                      {item.username}
                                    </p>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="d-flex name align-items-center">
                                      <p className="h6 gray-text m-0">
                                        {item.email}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="d-flex name align-items-center">
                                      {/* <button
                                        className="btn btn-outline-primary"
                                        type="button"
                                        onClick={()=>this.editUser(item.id)}
                                      >
                                        Edit user
                                      </button> */}
                                      <div>
                                        <Dropdown>
                                        <Dropdown.Toggle as={CustomToggle} id={`dropdown-${item.id}`} />
                                          <Dropdown.Menu 
                                          className="shadow-lg border-0 py-2"
                                          popperConfig={{
                                            modifiers: [
                                              {
                                                name: 'offset',
                                                options: {
                                                  offset: [15, 0],
                                                },
                                              },
                                            ],
                                          }}>
                                            <Dropdown.Item
                                              onClick={()=>this.editUser(item.id)}
                                            >Edit</Dropdown.Item>
                                            <Dropdown.Item
                                              onClick={()=>this.deleteUser(item.id)}
                                            >Delete</Dropdown.Item>
                                          </Dropdown.Menu>
                                        </Dropdown>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className="text-center py-4">
                                <p>No users found</p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Pagination */}
                    {displayedData?.length > 0 && (
                      <nav className="text-center mt-3 d-flex justify-content-center">
                        <ul className="pagination m-0 p-0">
                          <li
                            className={`page-item ${
                              currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() =>
                                this.updateDisplayedData(currentPage - 1)
                              }
                              disabled={currentPage === 1}
                            >
                              Previous
                            </button>
                          </li>
                          {renderPaginationButtons()}
                          <li
                            className={`page-item ${
                              currentPage === this.getPaginationGroup()
                                ? "disabled"
                                : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() =>
                                this.updateDisplayedData(currentPage + 1)
                              }
                              disabled={
                                currentPage === this.getPaginationGroup()
                              }
                            >
                              Next
                            </button>
                          </li>
                        </ul>
                      </nav>
                    )}
                  </div>
                </div>
              </div>
            )}
          </Layout>
        </section>
        <AddUserModal
          show={this.state.showUserModal}
          onHide={() => this.setShowUserModal()}
          editMode={this.state.editMode}
          userID={this.state.editUserId}
          setEditMode={this.setEditMode}
        />
        <DeleteUserModal
        show={showDeleteModal}
        onHide={this.handleDeleteCancel}
        onConfirm={this.handleDeleteConfirm}
        userName={userToDeleteName}
      />
      </>
    );
  }
}

export default AllUsers;
